import {notifications} from '@mantine/notifications';
import {Error} from '../api/generated/index.defs';
import {DefaultMantineColor} from '@mantine/core';
import {ReactNode} from 'react';

type MessageType = keyof typeof MessageTypes;
const MessageTypes = {
  success: 'Success',
  error: 'Error',
  info: 'Info',
  warning: 'Warning',
} as const;

const MessageTypeColors: Record<MessageType, DefaultMantineColor> = {
  success: 'green',
  error: 'red',
  info: 'blue',
  warning: 'yellow',
};

const notificationService = (() => {
  const createMessageType =
    (type: MessageType) => (message: string | ReactNode) => {
      notifications.show({
        title: MessageTypes[type],
        message: message,
        color: MessageTypeColors[type],
      });
    };

  const notifiers = {
    success: createMessageType('success'),
    error: createMessageType('error'),
    info: createMessageType('info'),
    warning: createMessageType('warning'),
  };

  return {
    ...notifiers,
    errors: (errors: Error[]) =>
      notifiers.error(errors.map((x) => x.errorMessage).join(',')),
    errorMap: (errors: Error[]) =>
      errors.map((x) => notifiers.error(x.errorMessage)),
  };
})();

export const useNotification = () => notificationService;